import * as React from 'react';
import { FormEvent, SyntheticEvent } from 'react';
import { FilterInterface } from '../../Filter/FilterInterface';
import { FilterDisableEvent } from './FilterDisableEvent';
import { FilterEvent } from './FilterEvent';
import { OptionsCollection } from './OptionsCollection';

export interface OptionsInterface {
    [key: string]: string
}

export type OptionsType<T = string> = OptionsCollection<T> | OptionsInterface | string[];

export interface FilterViewProps<VALUE_TYPE, FILTER_TYPE extends FilterInterface<VALUE_TYPE> = FilterInterface<VALUE_TYPE>> {
    onChange: (
        event: FilterEvent<VALUE_TYPE | undefined, any>,
        attr: string,
        filter: FilterInterface<VALUE_TYPE>
    ) => void
    filter: FILTER_TYPE
    hideDisable?: boolean
}

/**
 * View props for Filters that require user-provided Options
 */
export interface OptionsFilterViewProps<VALUE_TYPE, OPTION_TYPE> extends FilterViewProps<VALUE_TYPE> {
    options: OptionsType<OPTION_TYPE>
}

export abstract class AbstractFilterView<VALUE_TYPE, P extends FilterViewProps<VALUE_TYPE>, S = {}> extends React.Component<P, S> {
    constructor(props: Readonly<P>) {
        super(props);
        this.assertAttrOrFilter(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleDisable = this.handleDisable.bind(this);
    }

    public render() {
        return <div className="pf-filter">
            {this.renderInput()}
            {this.renderDisable()}
        </div>;
    }

    protected abstract renderInput(): JSX.Element | null;

    /**
     * @TODO: Check if F is needed
     * @param {React.FormEvent | FilterEvent<F, any>} event
     * @protected
     */
    protected handleChange<F = VALUE_TYPE>(event: FormEvent | FilterEvent<F, any>) {
        const props = this.props;
        this.assertAttrOrFilter(props);
        const attr = props.filter.keyPath;

        props.onChange(new FilterEvent(event), attr, props.filter);
    }

    protected handleDisable(_event: SyntheticEvent): void {
        const props = this.props;
        const attr = props.filter.keyPath;

        props.onChange(new FilterDisableEvent(), attr, props.filter);
    }

    protected renderDisable(): JSX.Element | null {
        const props = this.props;
        if (props.filter.isActive && !props.hideDisable) {
            return <div className="pf-filter-disable" onClick={this.handleDisable}>x</div>;
        } else {
            return null;
        }
    }

    protected assertAttrOrFilter(props: FilterViewProps<VALUE_TYPE>): void;
    protected assertAttrOrFilter(props: OptionsFilterViewProps<VALUE_TYPE, VALUE_TYPE>): void {
        if (!props.filter) {
            if (props.options) {
                console.debug('No "filter" provided. Given options:', props.options);
            }
            throw new TypeError('Property "filter" has to be provided');
        }
    }
}
